$(document).ready(function () {
    /* Scroll to form -- start */
    $("a.jobDetail__scrollToForm").on("click", function (e) {
        e.preventDefault();

        let href = $(this).attr("href");

        $("html, body").animate({
            scrollTop: $(href).offset().top-150
        }, {
            duration: 370,
            easing: "linear"
        });

        return false;
    });
    /* Scroll to form -- end */

    /*job file input -- start*/
    var _jobFileInput = $('#id-job-form-file');

    _jobFileInput.on('change', function () {
        var file = $(this)[0].files[0].name;
        $(this).siblings(".lk-form-file").addClass("hide").next('.lk-form-file-name').addClass("show").find("span").text(file);
    });

    _jobFileInput.siblings(".lk-form-file").next('.lk-form-file-name').find('.lk-form-file-remove').on('click', function(e) {
        e.preventDefault();
        $(this).parents(".lk-form-file-name").removeClass("show").next(".lk-form-file-input").val(null).parents(".lk-form-item").find(".lk-form-file").removeClass("hide").siblings(".lk-form-file-input");
    });
    /*job file input -- end*/

});
